<div *ngFor="let item of data | evaluationAggregate: 'starRatingItems'">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="aggregate-item">
    <p class="item-title" *ngIf="item.answers.length > 0">{{ item.questionName }}</p>
    <app-star-rating-aggregate-item
      *ngIf="item.answers.length > 0"
      [answers]="item.answers"
    ></app-star-rating-aggregate-item>
  </div>
  <mat-divider></mat-divider>
</div>
<div *ngFor="let item of data | evaluationAggregate: 'enumeratedItems'">
  <div class="aggregate-item">
    <p class="item-title">{{ item.questionName }}</p>
    <app-enumerated-aggregate-item
      [questionId]="item.questionId"
      [answers]="item.answers"
      [evaluatorsCount]="data.evaluatorsCount"
    ></app-enumerated-aggregate-item>
  </div>
  <mat-divider></mat-divider>
</div>
<div *ngFor="let item of data | evaluationAggregate: 'otherItems'">
  <div class="aggregate-item">
    <p class="item-title">{{ item.questionName }}</p>
    <p *ngFor="let answer of item.answers" [innerHTML]="answer | safeHtml" style="padding-left: 15px"></p>
  </div>
  <mat-divider></mat-divider>
</div>
